export { default as QuickUseTerms } from './QuickUseTerms';
export { default as QuickInfo } from './QuickInfo';

export {
  QuickLandingSlogan,
  QuickLandingTitle01,
  QuickLandingDesc01,
  QuickLandingTitle02,
  QuickLandingDesc02,
  QuickLandingItem01,
  QuickLandingItem02,
  QuickLandingTitle03,
  QuickLanding03ItemTitle01,
  QuickLanding03ItemDesc01,
  QuickLanding03ItemTitle02,
  QuickLanding03ItemDesc02,
  QuickLanding03ItemTitle03,
  QuickLanding03ItemDesc03,
  QuickLandingTitle04,
  QuickLandingDesc04,
  QuickLandingTitle0401,
  QuickLandingDesc0401,
  QuickLandingTitle0402,
  QuickLandingDesc0402,
  QuickLandingTitle0403,
  QuickLandingDesc0403,
  QuickLandingTitle05,
  QuickLandingDesc05,
  QuickLandingTitle055,
  QuickLandingDesc055,
  QuickLandingTitle06,
  QuickLandingDesc06
} from './quick/QuickLanding';

export {
  VehicleWarning,
  QuickAddressWarning,
  QuickReservationWarning,
  QuickReservation,
  QuickReservationAgreement,
  ServicePostMessage,
  ServicePostReception
} from './quick';

export {
  MealPermissionDesc,
  SikdaePauseCaution,
  SikdaeStartCaution,
  ServicePauseCaution,
  ServiceStartCaution,
  WelfarePauseCaution,
  WelfareStartCaution,
  WelfareDisabledNotice,
  WelfareActiveNotice,
  QuickDisabledNotice,
  QuickActiveNotice,
  SikdaeDisabledNotice,
  SikdaeActiveNotice
} from './management';

export {
  WLandingSlogan,
  WFooterTitle,
  WFooterDesc,
  WBannerTitle,
  WBannerTab01,
  WBannerTab02,
  wCardRowTitle,
  //
  WelfareLandingTitle01,
  WelfareLandingDesc01,
  WelfareLandingTitle02,
  WelfareLandingDesc02,
  WelfareLandingItem01,
  WelfareLandingItem02,
  WelfareLandingTitle03,
  WelfareLanding03ItemTitle01,
  WelfareLanding03ItemDesc01,
  WelfareLanding03ItemTitle02,
  WelfareLanding03ItemDesc02,
  WelfareLanding03ItemTitle03,
  WelfareLanding03ItemDesc03,
  WelfareLandingTitle04,
  WelfareLandingDesc04,
  WelfareLandingTitle0401,
  WelfareLandingDesc0401,
  WelfareLandingTitle0402,
  WelfareLandingDesc0402,
  WelfareLandingTitle0403,
  WelfareLandingDesc0403,
  WelfareLandingTitle05,
  WelfareLandingDesc05,
  WelfareLandingTitle055,
  WelfareLandingDesc055,
  WelfareLandingTitle06,
  WelfareLandingDesc06
} from './welfare/WelfareLanding';
